import { pick, toPairs, filter, compose, equals, head, tail } from 'ramda';
import React from 'react';
import autoBind from '../../modules/autoBind';
import utils from '../../modules/utils';
import '../app.scss';

export default class BenzingerResults extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    const dif = Math.abs(this.props.L1 - this.props.L2 * 4) + Math.abs(this.props.A1 - this.props.A2 * 4) + Math.abs(this.props.I1 - this.props.I2 * 4) + Math.abs(this.props.V1 - this.props.V2 *4);
    const sum = this.props.L2 * 4 + this.props.A2 * 4 + this.props.V2 * 4 + this.props.I2 * 4;

    const results = {
      changes: {
        'dFI 7': Math.abs(this.props.A1 - this.props.A2 * 4),
        'dPI 1': Math.abs(this.props.L1 - this.props.L2 * 4),
        'dPD 2': Math.abs(this.props.I1 - this.props.I2 * 4),
        'dFD 8': Math.abs(this.props.V1 - this.props.V2 * 4),
      },
      consistency: sum ? (1 - dif / sum) : null,
      change: dif
    };

    return (
      <div style={{ marginBottom: '10px' }}>
      <center>
          <table className='input-table' style={{marginBottom: '20px'}}>
            <thead>
              <tr>
                <td />
                <td key='Rac'>Rac</td>
                <td key='Cre'>Cre</td>
                <td key='Con'>Con</td>
                <td key='Prac'>Prac</td>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><b>Adulto</b></td>
                <td key='racAdulto'>{this.props.A1 + this.props.L1}</td>
                <td key='creAdulto'>{this.props.V1 + this.props.I1}</td>
                <td key='conAdulto'>{this.props.A1 + this.props.V1}</td>
                <td key='pracAdulto'>{this.props.L1 + this.props.I1}</td>
              </tr>
              <tr>
                <td><b>Joven</b></td>
                <td key='racJoven'>{this.props.A2 * 4 + this.props.L2 * 4}</td>
                <td key='creJoven'>{this.props.V2 * 4 + this.props.I2 * 4}</td>
                <td key='conJoven'>{this.props.A2 * 4 + this.props.V2 * 4}</td>
                <td key='pracJoven'>{this.props.L2 * 4 + this.props.I2 * 4}</td>
              </tr>
            </tbody>
          </table>
        </center>
        <div>
          <div><label>Índice de Consistencia:</label> {results.consistency === null ? '-' : utils.formatPercentage(results.consistency)}</div>
          <div><label>Niveles de Cambio entre Adulto y Joven:</label> {results.change}</div>
          {this.renderChanges(results.changes)}
        </div>
      </div>
    );
  }
  renderField(field) {
    return <td key={head(field)}>{tail(field)}</td>;
  }
  renderChanges(changes) {
    return toPairs(changes).map((change) => <div key={tail(head(change))}><label>Cambios en {tail(head(change))}:</label> {tail(change)}</div>)
  }
}



// WEBPACK FOOTER //
// ./src/App/benzinger/Results.jsx